<template>
    <div />
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class Home extends Vue {
    beforeMount() {
        const homePage = this.$store.state.user?.profile?.homePage
            ? this.$store.state.user?.profile?.homePage !== "home"
                ? this.$store.state.user.profile.homePage
                : "documents"
            : "login";
        this.$router.push({ name: homePage });
    }
}

export default toNative(Home);
</script>
